
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MembersList } from "@/components/Groups/MembersList/MembersList";
import { ChannelsList } from "@/components/Groups/ChannelsList/ChannelsList";
import { GroupChatroom } from "@/components/Groups/GroupChatroom";
import { GroupRole } from "@/lib/types";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

type GroupTabsProps = {
  groupId: string;
  currentUserRole: GroupRole;
  currentUserId: string;
};

export function GroupTabs({ 
  groupId, 
  currentUserRole, 
  currentUserId 
}: GroupTabsProps) {
  const [selectedChannelId, setSelectedChannelId] = useState<string | undefined>();
  const [groupName, setGroupName] = useState<string>("");

  useEffect(() => {
    fetchGroupName();
  }, [groupId]);

  const fetchGroupName = async () => {
    try {
      const { data: groupData } = await supabase
        .from("groups")
        .select("name")
        .eq("id", groupId)
        .single();
      
      if (groupData) {
        setGroupName(groupData.name);
      }
    } catch (error) {
      console.error("Error fetching group name:", error);
    }
  };

  return (
    <Tabs defaultValue="chat" className="w-full">
      <TabsList className="grid w-full grid-cols-3 mb-4">
        <TabsTrigger value="chat">Chat</TabsTrigger>
        <TabsTrigger value="channels">Channels</TabsTrigger>
        <TabsTrigger value="members">Members</TabsTrigger>
      </TabsList>
      
      <TabsContent value="chat">
        <GroupChatroom 
          groupId={groupId} 
          groupName={groupName}
          userRole={currentUserRole}
        />
      </TabsContent>
      
      <TabsContent value="channels">
        <ChannelsList
          groupId={groupId}
          userRole={currentUserRole}
        />
      </TabsContent>
      
      <TabsContent value="members">
        <MembersList
          groupId={groupId}
          currentUserRole={currentUserRole}
          currentUserId={currentUserId}
        />
      </TabsContent>
    </Tabs>
  );
}
